<template>
  <div :id="$style.over_view" :style="styles">
    <main-title
      v-observe-visibility="visibilityChanged_title"
      :class="{['animated slideInDown']: isVisible_title}"
      :main_title="main_title"
      :sub_title="sub_title"
      :color="color"
      :align="align"
    ></main-title>
    <div :class="$style.viewer">
      <slot name="viewer" :style="$style.viewer"></slot>
    </div>
    <div :class="$style.explain">
      <slot name="explain"></slot>
    </div>
    <div
      v-observe-visibility="visibilityChanged_btn"
      :class="{[$style.border]: true, ['animated slideInUp']: isVisible_btn}"
    ></div>
    <more-info-middle-button
      v-observe-visibility="visibilityChanged_btn"
      :class="{['animated slideInUp']: isVisible_btn}"
      :title="'More'"
      :link="link"
      :color="color"
    ></more-info-middle-button>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import MoreInfoMiddleButton from "@/components/atoms/MoreInfoMiddleButton.vue";

export default Vue.extend({
  name: "CustomerHomeVisual",

  components: {
    MainTitle,
    MoreInfoMiddleButton
  },
  data() {
    return {
      isVisible_title: Boolean,
      isVisible_btn: Boolean
    };
  },
  props: {
    main_title: {
      type: String,
      default: "MainTitle"
    },
    sub_title: {
      type: String,
      default: "SubTitle"
    },
    color: {
      type: String,
      default: "#000"
    },
    align: {
      type: String,
      default: "center"
    },
    link: {
      type: String,
      default: "/"
    }
  },

  computed: {
    styles() {
      return {
        "--color": this.color
      };
    }
  },
  methods: {
    visibilityChanged_title(isVisible) {
      this.isVisible_title = isVisible;
    },
    visibilityChanged_btn(isVisible) {
      this.isVisible_btn = isVisible;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #over_view {
    height: 550px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0px 10px;
    color: var(--color);
    .viewer {
      background-color: #fff;
      width: 300px;
      height: 200px;
      margin-top: 20px;
    }
    .explain {
      width: 300px;
      min-height: 100px;
      font-size: 13px;
      text-align: center;
      margin-top: 10px;
    }
    .border {
      margin: 10px 0px;
      border-left: 4px dashed;
      border-color: var(--color);
      height: 37px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #over_view {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0px 10px;
    color: var(--color);
    .viewer {
      background-color: #fff;
      width: 300px;
      height: 200px;
      margin-top: 20px;
    }
    .explain {
      width: 300px;
      min-height: 100px;
      font-size: 14px;
      text-align: center;
      margin-top: 10px;
    }
    .border {
      margin: 10px 0px;
      border-left: 4px dashed;
      border-color: var(--color);
      height: 37px;
    }
  }
}
</style>
